

















import { defineComponent, computed, PropType } from '@vue/composition-api';
import { Deployment } from '@/model/store';
import AppTimeAgo from '@/components/shared/TimeAgo.vue';
import { DeploymentState } from 'ionos-space-api-v4';
import { useI18n } from 'vue-i18n-bridge';

export default defineComponent({
  name: 'AppDeploymentDeploymentState',
  components: { AppTimeAgo },
  props: {
    deployment: {
      type: Object as PropType<Deployment>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();

    const label = computed<string>(() => {
      return t(`application.project.deployment.deploymentState.${props.deployment.state.state}`).toString();
    });
    const color = computed<string>(() => {
      switch (props.deployment.state.state) {
        case DeploymentState.SUCCESS:
          return 'success';
        case DeploymentState.RUNNING:
        case DeploymentState.IN_CREATION:
        case DeploymentState.QUEUED:
        case DeploymentState.CREATED:
          return 'info';
        case DeploymentState.FAILED:
          return 'error';
        default:
          return '';
      }
    });
    const icon = computed<string>(() => {
      switch (props.deployment.state.state) {
        case DeploymentState.SUCCESS:
          return 'mdi-check-circle-outline';
        case DeploymentState.RUNNING:
          return 'mdi-autorenew';
        case DeploymentState.CREATED:
        case DeploymentState.IN_CREATION:
        case DeploymentState.QUEUED:
          return 'mdi-timer-sand-empty';
        case DeploymentState.FAILED:
          return 'mdi-alert-circle-outline';
        default:
          return '';
      }
    });
    const hasFailedBuild = computed<boolean>(() => {
      switch (props.deployment.state.state) {
        case DeploymentState.FAILED:
          return true;
      }
      return false;
    });
    const githubActionUrl = computed<string | null>(() => {
      return props.deployment.state.url ?? null;
    });
    const lastDeploymentDate = computed<Date | undefined>(() => {
      return props.deployment.state.lastDeployedDate;
    });

    return {
      lastDeploymentDate,
      githubActionUrl,
      color,
      hasFailedBuild,
      icon,
      label,
    };
  },
});
